module.exports = __webpack_public_path__ + "static/challenge-c3de30b4b5b08ba75376cc6dd56f1566.jpg";